import React from "react";
import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import logo from "./images/logo.png";

const Footer = () => {
  return (
    <footer className="bg-dark text-light pt-5 pb-4 footer">
      <Container>
        <Row className="mb-5">
          <Col md={3} sm={12} className="mb-4">
            <img
              src={logo}
              alt="FixZip Chemical"
              width={150}
              style={{ background: "ivory" }}
            />
            <p className="mt-3">
              FixZip Chemical is your partner for advanced tile adhesives,
              waterproofing systems, epoxy grouts, and construction care —
              trusted by professionals nationwide.
            </p>

            <div className="mt-4">
              <h6 className="fw-bold">Opening Hours</h6>
              <p className="mb-1">Mon – Sat: 9:00 AM – 6:00 PM</p>
              <p className="mb-0">Sunday: Closed</p>
            </div>
          </Col>

          <Col md={3} sm={12} className="mb-4">
            <h5 className="fw-bold mb-3">Get in Touch</h5>
            <p>
              📧{" "}
              <a href="mailto:fixzipchemical@gmail.com" className="footer-link">
                fixzipchemical@gmail.com
              </a>
            </p>
            <p>
              📞{" "}
              <a href="tel:+919913867522" className="footer-link">
                +91 99138 67522
              </a>
            </p>
            <p>
              📞{" "}
              <a href="tel:+919408437877" className="footer-link">
                +91 94084 37877
              </a>
            </p>
            <address className="small">
              Sr. No. 77P/1, Opp. Ramdev Temple, Jabalpur,
              <br />
              Tankara–Rajkot Highway, Gujarat, India
            </address>

            <div className="mt-3">
              <a
                href="https://wa.me/919913867522"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-sm"
              >
                <FaWhatsapp className="me-2" />
                Chat on WhatsApp
              </a>
            </div>
          </Col>

          <Col md={3} sm={12} className="mb-4">
            <h5 className="fw-bold mb-3">Explore</h5>
            <ul className="list-unstyled footer-links">
              {["Home", "Products", "Services", "Why Us", "Contact Us"].map(
                (item, idx) => (
                  <li key={idx}>
                    <a
                      href={`/${
                        item === "Home"
                          ? ""
                          : item.toLowerCase().replace(" ", "-")
                      }`}
                      className="footer-link"
                    >
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </Col>

          <Col md={3} sm={12}>
            <h5 className="fw-bold mb-3">Stay Updated</h5>
            <p>Join our newsletter for product updates & expert tips.</p>
            <Form>
              <InputGroup className="mb-3">
                <Form.Control type="email" placeholder="Your email" />
                <Button variant="primary" type="submit">
                  Subscribe
                </Button>
              </InputGroup>
            </Form>

            <div className="mt-4">
              <h6 className="fw-bold mb-2">Follow Us</h6>
              <div className="d-flex gap-3 fs-5">
                <a href="#" className="text-light">
                  <FaFacebookF />
                </a>
                <a href="#" className="text-light">
                  <FaInstagram />
                </a>
                <a href="#" className="text-light">
                  <FaLinkedin />
                </a>
                <a href="#" className="text-light">
                  <FaTwitter />
                </a>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="border-secondary" />

        <Row>
          <Col className="text-center small">
            &copy; {new Date().getFullYear()} FixZip Chemical — Built with care
            for the construction industry.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
